// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { PATH_IMPORT_CSV } from 'components/PathImportCSV/constants'

import {
  CONTACT_NOT_FOUND,
  UNCAUGHT_ERROR,
} from 'errors'

import {
  assembleQuery,
  fetchContactsByQuery,
} from 'helpers/api'

import {
  getNestedByString,
  setNestedValueInObject,
} from 'helpers/reduxFormFunctions'

export const contactCodeIsValid = async (formValues, f, props, pathString) => {
  // if there's no pathString, that means this method was called on submit.
  // we don't need do this since we control async inputs' values tightly.
  // if it is being called on submit, you can just get outta here
  if (!pathString) {
    return
  }

  const {
    asyncErrors = {},
    change,
    dispatch,
    form,
  } = props

  // if this has length, then the input which triggered this is nested and not at the
  // top level of the form.
  const parentPath = pathString.substring(0, pathString.lastIndexOf(']') + 1)

  // if we're on PATH_IMPORT_CSV, treat the field names the same as
  // the path details would

  // if parentPath.length, then we're on a path details form
  // and that means we are assigning company/contact values for a segment end.
  // otherwise we're on the project-create or project-settigns form
  // in which case we're actually trying to set the default contact/company.
  const names = (
    form === PATH_IMPORT_CSV || parentPath.length
      ? {
        companyId: `${parentPath}companyId`,
        companyName: `${parentPath}companyName`,
        contactCode: pathString,
        contactId: `${parentPath}contactId`,
      } : {
        companyId: `${parentPath}defaultCompanyId`,
        companyName: `${parentPath}companyName`,
        contactCode: pathString,
        contactId: `${parentPath}defaultContactId`,
      }
  )

  const v = getNestedByString(formValues, pathString)
  const hasAsyncErrors = Object.keys(asyncErrors).length

  const setContactInfo = c => {
    dispatch(change(names.companyId, c.companyId || null))
    dispatch(change(names.companyName, c.companyName || ''))
    dispatch(change(names.contactCode, c.contactCode || ''))
    dispatch(change(names.contactId, c.contactId || null))
  }

  // if there aren't any async errors to track and there's no value for this input
  if (!hasAsyncErrors && !v.length) {
    return
  } else if (!v.length) {
    // even if there's no value, throw the asyncErrors object since
    // there may already be other async errors that we want to keep
    throw asyncErrors
  }

  try {
    // NOTE - this assumes that pathString is not a nested child
    // in the form's values.
    // TODO - must refactor pathString when this is used ith path details.
    const search = [{
      value: v,
      field: 'serviceContactCode',
      operator: 'EQ',
    }]
    const query = [{
      field: 'search',
      value: [search],
    }]
    const { entities } = await fetchContactsByQuery(assembleQuery(query))

    // there can only be one match here because contact code is unique
    // and we're looking for EQ here, not LIKE
    if (entities.length !== 1) {
      throw new Error(CONTACT_NOT_FOUND)
    }

    setContactInfo(entities[0])
  } catch (err) {
    console.warn(err)
    setNestedValueInObject(asyncErrors, pathString, err.message || UNCAUGHT_ERROR)
    throw asyncErrors
  }

  // even though everything went smoothly, we need to persist
  // any other async errors which are present
  if (hasAsyncErrors) {
    throw asyncErrors
  }
}
